const { createContext, useState, useEffect } = require("react");

const initialTheme = () => {
  let manuallyChosenTheme = "";
  if (typeof window !== "undefined" && window?.localStorage) {
    manuallyChosenTheme = localStorage.getItem("theme_mode");
    if (typeof manuallyChosenTheme === "string") {
      return manuallyChosenTheme;
    }

    const userAgentTheme =
      window?.matchMedia && window.matchMedia("(prefers-color-scheme : dark)");
    if (userAgentTheme?.matches) return "dark";
  }
  return "light";
};

export const CustomThemeContext = createContext();

export const CustomThemeProvider = ({ initial, children }) => {
  const [theme, setTheme] = useState(initialTheme);
  const updateDOMTheme = (choice) => {
    const html = window.document.documentElement;
    // check if theme is light
    const isLight = choice === "light";
    html.classList.remove(isLight ? "dark" : "light");
    html.classList.add(choice);
    localStorage.setItem("theme_mode", choice);
  };
  if (initial) {
    updateDOMTheme(initial);
  }
  useEffect(() => {
    updateDOMTheme(theme);
  }, [theme]);

  return (
    <CustomThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </CustomThemeContext.Provider>
  );
};
